import React from 'react';
import './DraftBody.css';

interface DraftBodyProps {
	text: string;
	maxChars?: number;
	className?: string;
}

const DraftBody: React.FC<DraftBodyProps> = ({ text, maxChars, className }) => {
	const content = React.useMemo(() => {
		if (typeof maxChars === 'number' && maxChars > 0 && text.length > maxChars) {
			return text.slice(0, maxChars) + '…';
		}
		return text;
	}, [text, maxChars]);

	return (
		<div className={`draft-body${className ? ` ${className}` : ''}`}>{content}</div>
	);
};

export default DraftBody;
